import React, {ReactNode} from 'react';
import capitalize from 'lodash/capitalize';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage} from 'gatsby-plugin-image';
import { Box, AppBar as AppBarMUI, Toolbar, Typography } from '@mui/material';
import GoldBox from './GoldBox';
import {Links as LinksProps, CustomFields, AppBar as AppBarProps} from '../../types/app'
import Link from './Link';

/*
const Logo = () => {
    const data = useStaticQuery(graphql`
        query {
            logo: file(relativePath: { eq: "logo_thumbnail.png" }) {
                childImageSharp {
                    gatsbyImageData(width: 50, layout: CONSTRAINED)
                }
            }
        }
    `);
    const logo = (
        data.logo 
            ? getImage(data.logo) 
            : null
    );
    if(!logo)
        return null;
    return (
        <Box sx={{mr:1,width:50}}>
            <GatsbyImage image={logo} alt="Logo" />
        </Box>
    )
}
*/

type LogoProps = {
    logo : CustomFields.Image
}

const LogoV2 : React.FC<LogoProps> = ({logo = undefined}) => {
    const image = logo ? getImage(logo) : null;
    if(!image)
        return null;
    return (
        <Box sx={{mr:1,width:50}}>
            <GatsbyImage image={image} alt="Logo" />
        </Box>
    )
}

/*
type AppBarProps = {
    children?: ReactNode,
    links?: LinksProps,
    [key: string]: any; // For any additional props
}
*/

const ensureSingleLeadingSlash = (path: string): string => `/${path.replace(/^\/+/, '')}`;

export const AppBar : React.FC<AppBarProps> = ({logo, links, ...props}) => {
    return (
        <AppBarMUI position="static" data-sb-object-id={props.contentful_id}>
            <GoldBox>
                <Toolbar>
                    
                    <Link to = "/" sx={{m:0.5}}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <LogoV2 logo={logo}/>
                            <Typography component="p" sx={{fontWeight:800, fontSize:`40px!important`, whiteSpace:'nowrap'}}>
                                { SITE_METADATA.companyName }
                            </Typography>
                        </Box>
                    </Link>
                    
                    <Box flexGrow={1} sx={{color:'black'}} />

                    <Box sx={{display:'inline-block', "& > * + *" : { ml : 1}}}>
                        {
                            (links?.links || []).map(({slug,contentful_id}) => (
                                <Link to={ensureSingleLeadingSlash(`/${slug}`)} data-sb-object-id={contentful_id} key={contentful_id}>
                                    <Typography variant="h6" component="span" data-sb-field-path = "slug" >
                                        { capitalize(slug === '/' ? 'home' : slug) }
                                    </Typography>
                                </Link>
                            ))
                        }
                    </Box>
                </Toolbar>
            </GoldBox>
        </AppBarMUI>
    )
}

export default AppBar;